import { lighten } from 'polished';

import { withTracker } from '@/tracker';
import { colors } from '@/themes';
import useNavbarBackground from '@/hooks/use-navbar-background';
import SEO from '@/components/seo';
import Hero from '@/components/contact/hero';
import ContactInfo from '@/components/contact/contact-info';

function Contact () {
  useNavbarBackground(lighten(.35, colors.brand.primary));

  return (
    <>
      <SEO
        title="Contact Bidali"
        description="Every way to contact the team at Bidali." />
      <Hero />
      <ContactInfo />
    </>
  );
}

export default withTracker(Contact);
